import { FC } from 'react';

import { ImagePackSetVariation } from '@rikstv/play-common/src/utils/imagePack/imagePack.utils';

import { Breakpoints } from '../../grid/breakpoints';

import { StandardItem, StandardItemProps } from './StandardItem';

export const PortraitItem: FC<StandardItemProps> = props => <StandardItem {...props} />;

export const standardPortraitImageConfig: ImagePackSetVariation[] = [
  { width: 150, height: 225, breakpoint: Breakpoints.SM },
  { width: 200, height: 300, breakpoint: Breakpoints.MD },
];

export const heroPortraitImageConfig: ImagePackSetVariation[] = [
  { width: 225, height: 340, breakpoint: Breakpoints.SM },
  { width: 250, height: 375, breakpoint: Breakpoints.MD },
];
